import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import './Staff.css';

const Staff = () => {
  const coaches = [
    {
      name: 'David Wong',
      role: 'Founder & Head Coach',
      image: 'https://randomuser.me/api/portraits/men/45.jpg',
      bio: 'Former national team player with 20+ years of competitive experience. David founded Net Nest with a vision to make world-class badminton training accessible to everyone.',
      credentials: ['BWF Level 3 Certified', 'National Team (2000-2010)', '5x State Champion'],
      social: { facebook: '#', twitter: '#', instagram: '#', linkedin: '#' }
    },
    {
      name: 'Maria Santos',
      role: 'Co-Founder & Operations Director',
      image: 'https://randomuser.me/api/portraits/women/44.jpg',
      bio: 'Sports management expert with a passion for badminton. Maria ensures Net Nest runs smoothly and maintains the highest standards of service and facility excellence.',
      credentials: ['MBA in Sports Management', 'Certified Sports Administrator', '15 Years Industry Experience'],
      social: { facebook: '#', twitter: '#', instagram: '#', linkedin: '#' }
    },
    {
      name: 'Sarah Chen',
      role: 'Senior Coach - Competitive',
      image: 'https://randomuser.me/api/portraits/women/32.jpg',
      bio: 'International tournament player turned coach. Sarah specializes in training competitive players and has mentored several state-level champions.',
      credentials: ['BWF Level 2 Certified', 'Asian Games Participant', 'Youth Development Specialist'],
      social: { facebook: '#', twitter: '#', instagram: '#', linkedin: '#' }
    },
    {
      name: 'Michael Rodriguez',
      role: 'Performance Coach',
      image: 'https://randomuser.me/api/portraits/men/28.jpg',
      bio: 'Sports science graduate with expertise in athletic performance. Michael combines technical coaching with physical conditioning for optimal player development.',
      credentials: ['Sports Science Degree', 'High Performance Certified', 'Strength & Conditioning Specialist'],
      social: { facebook: '#', twitter: '#', instagram: '#', linkedin: '#' }
    },
    {
      name: 'Jennifer Liu',
      role: 'Junior Academy Director',
      image: 'https://randomuser.me/api/portraits/women/68.jpg',
      bio: 'Passionate about nurturing young talent, Jennifer leads our junior academy with innovative training methods designed specifically for young athletes.',
      credentials: ['Child Development Certified', 'Former Junior National Coach', 'Physical Education Degree'],
      social: { facebook: '#', twitter: '#', instagram: '#', linkedin: '#' }
    },
    {
      name: 'Robert Kim',
      role: 'Coach - Adult Programs',
      image: 'https://randomuser.me/api/portraits/men/52.jpg',
      bio: 'Experienced coach specializing in adult recreational and fitness-focused badminton. Robert makes learning fun and effective for players of all backgrounds.',
      credentials: ['BWF Level 2 Certified', 'Personal Training Certified', '10 Years Coaching Experience'],
      social: { facebook: '#', twitter: '#', instagram: '#', linkedin: '#' }
    }
  ];

  const support = [
    {
      name: 'Amanda Taylor',
      role: 'Front Desk Manager',
      image: 'https://randomuser.me/api/portraits/women/55.jpg'
    },
    {
      name: 'James Park',
      role: 'Facilities Manager',
      image: 'https://randomuser.me/api/portraits/men/35.jpg'
    },
    {
      name: 'Lisa Wang',
      role: 'Pro Shop Manager',
      image: 'https://randomuser.me/api/portraits/women/42.jpg'
    },
    {
      name: 'Kevin Martinez',
      role: 'Events Coordinator',
      image: 'https://randomuser.me/api/portraits/men/22.jpg'
    }
  ];

  return (
    <div className="staff-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <span className="page-badge">Our Team</span>
            <h1>Meet Our Staff</h1>
            <p>Dedicated professionals passionate about badminton excellence</p>
            <nav className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Our Staff</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Leadership & Coaches */}
      <section className="section coaches-main">
        <div className="container">
          <div className="section-header center">
            <span className="section-badge">Leadership & Coaches</span>
            <h2>The Heart of Net Nest</h2>
            <p>Our experienced team brings passion, expertise, and dedication to every session</p>
          </div>
          <div className="coaches-grid-main">
            {coaches.map((coach, index) => (
              <div className="coach-card-main" key={index}>
                <div className="coach-image">
                  <img src={coach.image} alt={coach.name} />
                  <div className="coach-social">
                    <a href={coach.social.facebook} aria-label="Facebook"><FaFacebookF /></a>
                    <a href={coach.social.twitter} aria-label="Twitter"><FaTwitter /></a>
                    <a href={coach.social.instagram} aria-label="Instagram"><FaInstagram /></a>
                    <a href={coach.social.linkedin} aria-label="LinkedIn"><FaLinkedinIn /></a>
                  </div>
                </div>
                <div className="coach-info">
                  <h3>{coach.name}</h3>
                  <span className="coach-role">{coach.role}</span>
                  <p className="coach-bio">{coach.bio}</p>
                  <div className="coach-credentials">
                    {coach.credentials.map((cred, idx) => (
                      <span key={idx}>{cred}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Support Staff */}
      <section className="section support-section">
        <div className="container">
          <div className="section-header center">
            <span className="section-badge">Support Team</span>
            <h2>Behind the Scenes</h2>
            <p>The team that keeps Net Nest running smoothly</p>
          </div>
          <div className="support-grid">
            {support.map((member, index) => (
              <div className="support-card" key={index}>
                <img src={member.image} alt={member.name} />
                <h4>{member.name}</h4>
                <span>{member.role}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Team CTA */}
      <section className="join-team section">
        <div className="container">
          <div className="join-team-content">
            <div className="join-text">
              <span className="section-badge">Careers</span>
              <h2>Join Our Team</h2>
              <p>
                Are you passionate about badminton and helping others succeed?
                We're always looking for talented coaches and staff members to join
                the Net Nest family.
              </p>
              <Link to="/contact" className="btn btn-primary">View Openings</Link>
            </div>
            <div className="join-image">
              <img src="https://images.unsplash.com/photo-1613918431703-aa50889e3be6?w=500" alt="Join Team" />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Train with the Best?</h2>
            <p>Book a session with our expert coaches today</p>
            <div className="cta-buttons">
              <Link to="/training" className="btn btn-white">View Programs</Link>
              <Link to="/contact" className="btn btn-outline-white">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Staff;
